<template>
  <form class="aviso-container" ref="avisoContent" @submit.prevent="handleSubmit">
    <div class="contenido-principal">
      <!-- Página 1 -->
      <div class="pagina">
        <!-- Encabezado con logo -->
        <div class="document-header">
          <div class="left-container">
            <div class="logo-placeholder">
              <img :src="logo" class="logo" alt="Company Logo" v-if="true">
              <div class="logo-text" v-else>LOGO</div>
            </div>
          </div>
          <div class="address-section">
            <p>Robert Schumann 4898</p>
            <p>Col. Lomas del seminario, CP.45038</p>
            <p>Zapopan, Jalisco.</p>
          </div>
        </div>

        <!-- Títulos -->
        <h1 class="titulo-seccion">AVISO DE PRIVACIDAD</h1>
        <h5 class="subtitulo-seccion">AVISO DE PRIVACIDAD</h5>
        <hr class="divisor" />

        <!-- Contenido Página 1 -->
        <div class="contenido-texto">
          <p>
            KVF GROUP S.A. DE C.V., en adelante para efectos del presente aviso denominado como (KVF) conocido
            comercialmente como Goldbergfund, con domicilio en Robert Schumann número 4898 Col. Lomas del
            seminario, Zapopan, Jalisco, México, C.P. 45038, es responsable de recabar sus datos personales, del
            uso que se dé a los mismos y de su protección.
          </p>

          <h4><u>Datos personales sujetos a tratamiento por KVF:</u></h4>
          <p>
            Para cumplir con las finalidades previstas en el presente Aviso de Privacidad, KVF recabará la
            siguiente información:
          </p>
          <p>
            Datos de Identificación, Datos migratorios, Datos de contacto, Datos de ubicación, Datos laborales, Datos
            académicos, Datos de referencias, Datos de Aval(es), Datos de Obligado(s) Solidario(s), Datos patrimoniales
            y/o financieros, y Geolocalización.
          </p>

          <p>
            KVF podrá dar tratamiento a datos personales de identificación y contacto de terceros para validar la
            información que nos proporcione. Al proporcionar esta información reconoce haber informado a dichos
            terceros sobre el uso de sus datos y haber obtenido de forma previa el consentimiento de estos últimos.
          </p>

          <h4><u>Datos sensibles</u></h4>

          <p>
            Para proporcionarte nuestros productos y servicios, KVF recabará las siguientes categorías de datos
            personales
            sensibles:
          </p>

          <p>Datos biométricos, (específicamente huellas dactilares). </p>

          <h4><u>Finalidad del tratamiento de sus datos personales:</u></h4>

          <p>
            KVF tratará los datos personales descritos en el presente aviso de privacidad para cumplir con las
            finalidades
            primarias que se indican a continuación:
          </p>

          <p>
            Para el cumplimiento de la relación contractual derivada de la solicitud y/o contratación de nuestros
            productos o servicios;
          </p>

          <p>Verificar, confirmar y validar tu identidad; </p>

          <p>Consultar tu historial crediticio; </p>

          <p>Administrar, operar y dar seguimiento a los servicios y productos solicitados o contratados con KVF;</p>

          <p>
            Enviarle notificaciones con información sobre los productos o servicios contratados. Esto puede incluir el
            envío
            de comunicaciones a través de correos electrónicos, llamadas telefónicas, mensajes cortos, y demás medios
            de comunicación físicos, electrónicos y/o digitales;
          </p>

          <p>Realizar gestiones de cobranza;</p>

          <p>Atender y operar solicitudes relacionadas con la portabilidad y/o movilidad de créditos.</p>
          <p>Instrumentación de operaciones de crédito a través de Federarios Públicos;</p>
        </div>
      </div>

      <div class="separado-page"></div>

      <!-- Página 2 -->
      <div class="pagina">
        <!-- Encabezado con logo -->
        <div class="document-header">
          <div class="left-container">
            <div class="logo-placeholder">
              <img :src="logo" class="logo" alt="Company Logo" v-if="true">
              <div class="logo-text" v-else>LOGO</div>
            </div>
          </div>
          <div class="address-section">
            <p>Robert Schumann 4898</p>
            <p>Col. Lomas del seminario, CP.45038</p>
            <p>Zapopan, Jalisco.</p>
          </div>
        </div>

        <!-- Contenido Página 2 -->
        <div class="contenido-texto">
          <p>
            Identificar y prevenir posibles conductas ilícitas que pudieran significar una violación a las
            disposiciones legales vigentes;
          </p>

          <p>
            Realizar procesos de auditoría interna y externa;
          </p>

          <p>
            Cumplir con las obligaciones establecidas por la legislación aplicable y las autoridades
            competentes.
          </p>

          <h4><u>Transferencias de datos personales</u></h4>
          <p>
            KVF podrá transferir tus datos personales tanto a entidades nacionales como extranjeras, sin requerir tu
            consentimiento en los siguientes supuestos:
          </p>
          <p>
            A empresas nacionales e internacionales en caso de que sea requerido para cumplir con las finalidades
            previstas en el presente aviso de privacidad.
          </p>
          <p>
            Al Instituto Nacional Electoral para validar tu identidad;
          </p>
          <p>
            A Sociedades de Información Crediticia para cumplir con obligaciones derivadas de la relación jurídica entre
            usted y KVF, así como para cumplir con disposiciones legales vigentes;
          </p>
          <p>
            Socios comerciales con quienes se tengan celebrados contratos para la comercialización de productos y/o
            servicios, en beneficio y/o interés de los clientes.
          </p>
          <p>
            Empresas de mensajería para el envío de comunicaciones relacionadas con los productos y/o servicios
            contratados;
          </p>
          <p>
            Empresas privadas o entidades públicas, en su calidad de patrón, para procesos relacionados con dispersiones
            de nómina;
          </p>
          <p>
            Empresas adquirentes de deuda con quienes se celebre un contrato de venta de cartera;
          </p>
          <p>
            Fedatarios Públicos para la instrumentación de las operaciones de crédito;
          </p>
          <p>
            Instituciones financieras;
          </p>
          <p>
            Autoridades competentes en los casos legalmente previstos.
          </p>
          <h4>
            <u>
              Medio y procedimiento para ejercer Derechos ARCO y/o revocación de consentimiento para el tratamiento
              de datos personales
            </u>
          </h4>
          <p>
            Los derechos ARCO son los siguientes:
          </p>
          <ul class="lista-guiones">
            <li><strong>A</strong>cceso. Le ayuda a conocer los datos personales que KVF tiene registrados y asociados
              contigo.</li>
            <li><strong>R</strong>ectificación. Es para actualizar los datos personales que KVF tiene registrados.</li>
            <li><strong>C</strong> ancelación. Elimina los datos personales que KVF tiene registrados.</li>
            <li><strong>O</strong>posición. Evita el uso de sus datos personales para fines distintos a la relación
              contractual que tenga
              con KVF.</li>
          </ul>
          <p>
            Usted o su representante legal podrán ejercer cualquiera de los derechos de acceso, rectificación,
            cancelación u oposición, así como revocar su consentimiento para el tratamiento de sus datos personales
            enviando un correo electrónico a la siguiente dirección: <a
              href="mailto:juridico@golbergfund.com">juridico@golbergfund.com</a>.
          </p>
          <p>La petición deberá ser realizada mencionando cuál o cuáles de los derechos ARCO desea ejercer. Para que
            KVF pueda darle seguimiento a la solicitud, usted o su representante legal deberán acreditar correctamente
          </p>
        </div>
      </div>

      <div class="separado-page"></div>

      <!-- Página 3 -->
      <div class="pagina">
        <!-- Encabezado con logo -->
        <div class="document-header">
          <div class="left-container">
            <div class="logo-placeholder">
              <img :src="logo" class="logo" alt="Company Logo" v-if="true">
              <div class="logo-text" v-else>LOGO</div>
            </div>
          </div>
          <div class="address-section">
            <p>Robert Schumann 4898</p>
            <p>Col. Lomas del seminario, CP.45038</p>
            <p>Zapopan, Jalisco.</p>
          </div>
        </div>

        <!-- Contenido Página 3 -->
        <div class="contenido-texto">
          <p>
            su identidad, por lo que es necesario que se acompañe dicha solicitud con copia de alguna identificación
            oficial vigente, las identificaciones válidas son las siguientes: INE, cédula profesional, pasaporte, FM2 o
            FM3.
          </p>
          <p>
            Si la solicitud la hará a través de un representante legal, debe incluir como archivos adjuntos su
            identificación
            y el poder notarial correspondiente, o una carta poder firmada por dos testigos.
          </p>
          <p>
            En caso de que la información proporcionada en la solicitud sea errónea o insuficiente, o bien, no se
            acompañen los documentos de acreditación correspondientes, dentro de los cinco (5) días hábiles siguientes
            a la recepción de la solicitud, KVF podrá requerir que aporte los elementos o documentos necesarios para dar
            trámite a la misma. Contará con diez (10) días hábiles para atender el requerimiento, contados a partir del
            día
            siguiente en que lo haya recibido. De no dar respuesta en dicho plazo, se tendrá por no presentada la
            solicitud
            correspondiente.
          </p>
          <p>
            KVF comunicará la determinación adoptada, en un plazo máximo de veinte (20) días hábiles contados desde
            la fecha en que se recibió la solicitud, a efecto de que, si resulta procedente, haga efectiva la misma
            dentro
            de los quince (15) días hábiles siguientes a que se comunique la respuesta. La respuesta se otorgará por la
            vía
            o medio que haya especificado en la solicitud y en caso de no haber especificado, será a través del correo
            electrónico del que envió su solicitud.
          </p>
          <h4><u>Opciones y medios para limitar el uso o divulgación de datos personales</u></h4>
          <p>
            Podrá limitar el uso o divulgación de sus datos personales enviando un correo electrónico a:
            <a href="mailto:juridico@golbergfund.com">juridico@golbergfund.com</a>. Los requisitos para acreditar su
            identidad, así como el procedimiento para atender
            su solicitud se regirán por los mismos criterios señalados en el apartado anterior. En caso de que su
            solicitud
            resulte procedente, KVF lo registrará en el listado de exclusión propio.
          </p>
          <h4><u>Cambios al aviso de privacidad</u></h4>
          <p>
            KVF se reserva el derecho, bajo su exclusiva discreción, de cambiar, modificar, agregar o eliminar partes
            del
            presente aviso de privacidad en cualquier momento. En tal caso, KVF enviará la notificación relativa a
            dichos
            cambios así como el nuevo aviso a través del correo <a
              href="mailto:juridico@golbergfund.com">juridico@golbergfund.com</a>.
          </p>
          <p>
            KVF GROUP S.A. DE C.V., no recabará datos sensibles de usted. Por la firma del presente Aviso, usted
            consciente
            para todos los efectos legales el tratamiento y recopilación de sus datos personales. Por lo tanto, sus
            datos
            personales serán tratados por KVF GROUP S.A. DE C.V., bajo los principios de licitud, consentimiento,
            información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad de conformidad con lo dispuesto
            por el artículo 6 de la Ley Federal de Protección a los Datos Personales en Posesión de los Particulares.
          </p>
          <p>
            Asimismo, por la firma de este Aviso, usted consiente que KVF GROUP S.A. DE C.V., podrá transferir a
            terceros
            sus datos personales cuando la transferencia sea precisa para el mantenimiento o cumplimiento de una
            relación jurídica con usted, y KVF GROUP S.A. DE C.V., podrá transferir sus datos personales a sus empresas
            afiliadas, subsidiarias y/o asociadas para las finalidades indicadas en el presente aviso.
          </p>
          <p>
            KVF GROUP S.A. DE C.V., tiene implementadas medidas de seguridad sistemáticas para proteger sus datos
            personales de uso o divulgación.
          </p>
        </div>

        <!-- Campos de firma -->
        <div class="firma-section">
          <p class="fecha-actualizacion">Última fecha de actualización: 14 julio de 2022.</p>
          <div class="campo-field">
            <span>Nombre: </span>
            <input type="text" v-model="nombre" class="underline-input underline-input-xl" disabled />
          </div>
          <div class="campo-field">
            <span>Fecha: </span>
            <input type="date" v-model="fecha" class="underline-input" required />
          </div>
          <div class="campo-field">
            <span>Firma: </span>
            <input type="text" v-model="firma" class="underline-input underline-input-md" />
          </div>
        </div>
      </div>

      <!-- Botón de descarga -->
      <div class="form-actions">
        <button class="download-btn">Descargar PDF</button>

        <div v-if="validationErrors.length" class="validation-errors">
          <p v-for="(error, index) in validationErrors" :key="index" class="error-message">{{ error }}</p>
        </div>

      </div>
    </div>
  </form>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { usePrivacyPolicyStore } from '@/pinia/LoanApplications/Legal/usePrivacyPolicyStore.module';

const store = usePrivacyPolicyStore();
const avisoContent = ref(null);
const validationErrors = ref([]);

// Acceder a la instancia de la app
const app = getCurrentInstance();
const filters = app?.appContext.config.globalProperties.$filters;

// Acceso a las propiedades del store
const logo = computed(() => store.logo);
const nombre = computed({
  get: () => store.nombre,
  set: (value) => { store.nombre = value; }
});
const fecha = computed({
  get: () => {
    if (!store.fecha) return '';
    return filters?.formatDateForInput?.(store.fecha) || store.fecha;
  },
  set: (value) => { store.fecha = value; }
});
const firma = computed({
  get: () => store.firma,
  set: (value) => { store.firma = value; }
});

onMounted(() => {
  store.setAvisoContent(avisoContent.value);
});

const validateForm = () => {
  validationErrors.value = [];
  let isValid = true;

  // Validación de campos requeridos
  const requiredFields = [
    { field: 'fecha', message: 'La fecha de emisión es requerida' }
  ];

  requiredFields.forEach(({ field, message }) => {
    // const value = field === 'fecha' ? fecha.value : 
    //              field === 'nombre' ? nombre.value : 
    //              field === 'firma' ? firma.value : null;

    const value = field === 'fecha' ? fecha.value : null;

    if (!value?.toString().trim()) {
      validationErrors.value.push(message);
      isValid = false;
    }
  });

  return isValid;
}

const handleSubmit = () => {
  if (validateForm()) {
    store.saveData();
  } else {
    this.$nextTick(() => {
      const errorElement = document.querySelector('.validation-errors');
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
};
</script>

<style scoped>
/* Estilos generales */
.aviso-container {
  font-family: Arial, sans-serif;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-left: 80px solid #f8a845;
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 60px;
  color: #000;
  break-inside: avoid;
  /* Evitar que se rompa entre páginas */
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.document-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.left-container {
  display: flex;
  align-items: flex-start;
}

.left-container {
  width: 120px;
  display: flex;
  align-items: center;
}

.logo {
  max-width: 200%;
  max-height: 200%;
}

.logo-placeholder {
  width: 200%;
  display: flex;
  align-items: center;
  color: #999;
}

.logo-text {
  display: inline-block;
  border: 1px dashed #999;
  padding: 10px 20px;
  color: #666;
  font-weight: bold;
}

.address-section {
  text-align: right;
  line-height: 0.4;
  margin-top: 10px;
  align-content: center;
}

.contenido-principal {
  flex: 1;
  padding: 5mm 10mm 0 10mm;
  /* Elimina padding-bottom */
  margin-bottom: 0;
  overflow: hidden;
}

.pagina {
  position: relative;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.separado-page {
  padding-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  border-bottom: 1px dashed #ccc;
}

.mode-print {
  /*min-height: 297mm;*/
  min-height: 293.5mm !important;
  padding-bottom: 0 !important;
}

.pagina:empty {
  display: none !important;
}

.pagina:not(:has(*:not(script):not(style):not([hidden]))) {
  display: none !important;
}

/* Títulos */
.titulo-seccion {
  color: #000;
  font-size: 15px;
  /* Tamaño ajustado */
  text-align: center;
  text-transform: uppercase;
  margin: 10px 0 20px 0;
  font-weight: bold;
}

.subtitulo-seccion {
  color: #000;
  font-size: 12px;
  /* Tamaño ajustado */
  text-align: center;
  font-weight: bold;
  margin-bottom: 15px;
}

.titulo-marca {
  color: #000;
  font-size: 16px;
  /* Tamaño ajustado */
  text-align: center;
  text-transform: uppercase;
  margin: 10px 0 15px 0;
  font-weight: bold;
}

.divisor {
  border: 0;
  border-top: 1px solid #000;
  margin: 8px 0 25px;
  width: 100%;
}

/* Contenido */
.contenido-texto {
  font-size: 11.6px;
  /* Tamaño más pequeño como en el original */
  line-height: 1.2;
  /* Interlineado más ajustado */
  text-align: justify;
}

.contenido-texto h4 {
  font-size: 11.6px;
  font-weight: bold;
  margin: 12px 0 8px 0;
  text-decoration: underline;
}

.lista-guiones {
  list-style-type: none;
  padding-left: 1em;
  margin: 8px 0;
}

.lista-guiones li {
  position: relative;
  padding-left: 1em;
  margin-bottom: 0.3em;
  font-size: 11.6px;
}

.lista-guiones li::before {
  content: "-";
  position: absolute;
  left: 0;
}

/* Sección de firma */
.firma-section {
  margin-top: 30px;
  font-size: 11.6px;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}

.fecha-actualizacion {
  font-weight: bold;
  margin-bottom: 25px;
  text-align: left;
}

.campo-field {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.campo-field label {
  min-width: 50px;
  margin-right: 10px;
}

.input-firma {
  flex-grow: 1;
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  padding: 0 0 2px 0;
  font-family: inherit;
  font-size: inherit;
  height: 18px;
  outline: none;
}

.input-firma:focus {
  border-bottom: 2px solid #000;
}

.campo-field span {
  white-space: nowrap;
  font-size: 11.6px;
  margin-right: 15px;
}

.underline-input {
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  font-family: Arial, sans-serif;
  margin-right: 8px;
}

.underline-input-sm {
  width: 12%;
}

.underline-input-md {
  width: 25%;
}

.underline-input-lg {
  width: 50%;
}

.underline-input-xl {
  width: 100%;
}

.underline-input:focus,
.underline-input-sm:focus,
.underline-input-md:focus,
.underline-input-lg:focus,
.underline-input-xl:focus {
  outline: none;
  border-bottom: 2px solid #f8a845;
}

/* Botón de descarga */
.form-actions {
  text-align: center;
  width: 100%;
  padding-bottom: 20px;
}

.download-btn {
  background-color: #f8a845;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.download-btn:hover {
  background-color: #E05D00;
}

/* Agrega estos estilos Validaciones */
.validation-errors {
  margin-top: 15px;
  padding: 10px;
  background-color: #ffeeee;
  border: 1px solid #ffcccc;
  border-radius: 4px;
}

.error-message {
  color: #d32f2f;
  margin: 5px 0;
  font-size: 0.9em;
}

/* Estilo para campos inválidos */
input:invalid {
  border-color: #d32f2f;
}

/* Estilos para impresión */
@media print {
  .aviso-container {
    box-shadow: none;
  }

  .input-firma {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    border-bottom: 1px solid #000;
    background: transparent;
    padding-bottom: 2px;
  }

  .input-firma::placeholder {
    color: transparent;
  }

  .campo-field {
    page-break-inside: avoid;
  }

  .form-actions {
    display: none;
  }

  .franja-naranja {
    width: 15mm;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .aviso-container {
    padding-left: 15mm;
  }

  .pagina:last-child {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    overflow: hidden;
  }

  /* Ocultar el aspecto de input en el PDF generado */
  .underline-input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    border-bottom: 1px solid #000;
    background: transparent;
    padding-bottom: 2px;
  }

  .underline-input[type="date"] {
    min-width: 80px;
  }
}
</style>